import { action, payload } from "ts-action";
import { HegUserDTO, MappingStateDTO } from "../../requests/hegMapping/types";

// Check mapping

export const checkMappingRequest = action(
  "HEG MAPPING > CHECK MAPPING > REQUEST",
  payload<{ datasourceId: number }>()
);

export const checkMappingResponse = action(
  "HEG MAPPING > CHECK MAPPING > RESPONSE",
  payload<{
    datasourceId: number;
    userMapping: MappingStateDTO;
    defaultMapping: MappingStateDTO;
  }>()
);

export const checkMappingError = action(
  "HEG MAPPING > CHECK MAPPING > ERROR",
  payload<{ datasourceId: number }>()
);

// Get heg user

export const getHegUserRequest = action(
  "HEG MAPPING > GET MAPPED USER > REQUEST",
  payload<{ datasourceId: number }>()
);

export const getHegUserResponse = action(
  "HEG MAPPING > GET MAPPED USER > RESPONSE",
  payload<{ datasourceId: number; user: HegUserDTO }>()
);

export const getHegUserError = action(
  "HEG MAPPING > GET MAPPED USER > ERROR",
  payload<{ datasourceId: number }>()
);

// Update heg user

export const updateHegUserRequest = action(
  "HEG MAPPING > UPDATE MAPPED USER > REQUEST",
  payload<{ datasourceId: number; newHegUser: string }>()
);

export const updateHegUserResponse = action(
  "HEG MAPPING > UPDATE MAPPED USER > RESPONSE",
  payload<{ datasourceId: number; user: HegUserDTO; defaultMapping: boolean }>()
);

export const updateHegUserError = action(
  "HEG MAPPING > UPDATE MAPPED USER > ERROR",
  payload<{ datasourceId: number }>()
);

// Reset mapped user

export const resetHegUserRequest = action(
  "HEG MAPPING > RESET MAPPED USER > REQUEST",
  payload<{ datasourceId: number }>()
);

export const resetHegUserResponse = action(
  "HEG MAPPING > RESET MAPPED USER > RESPONSE",
  payload<{ datasourceId: number }>()
);

export const resetHegUserError = action(
  "HEG MAPPING > RESET MAPPED USER > ERROR",
  payload<{ datasourceId: number }>()
);

// Reset default mapped user

export const resetDefaultHegUserRequest = action(
  "HEG MAPPING > RESET DEFAULT MAPPED USER > REQUEST",
  payload<{ datasourceId: number }>()
);

export const resetDefaultHegUserResponse = action(
  "HEG MAPPING > RESET DEFAULT MAPPED USER > RESPONSE",
  payload<{ datasourceId: number }>()
);

export const resetDefaultHegUserError = action(
  "HEG MAPPING > RESET DEFAULT MAPPED USER > ERROR",
  payload<{ datasourceId: number }>()
);

// Submit mapping password

export const submitHegPasswordRequest = action(
  "HEG MAPPING > SUBMIT MAPPED PASSWORD > REQUEST",
  payload<{ datasourceId: number }>()
);

export const submitHegPasswordResponse = action(
  "HEG MAPPING > SUBMIT MAPPED PASSWORD > RESPONSE",
  payload<{ datasourceId: number }>()
);

export const submitHegPasswordError = action(
  "HEG MAPPING > SUBMIT MAPPED PASSWORD > ERROR",
  payload<{ datasourceId: number }>()
);
